const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

export const getPromoteValidationMessages = (error: unknown): string[] => {
  if (!isRecord(error) || !isRecord(error.data)) {
    return [];
  }

  if (Array.isArray(error.data.errors)) {
    const fieldMessages = error.data.errors.flatMap((fieldError: unknown) => {
      if (!isRecord(fieldError) || typeof fieldError.details !== "string" || fieldError.details.length === 0) {
        return [];
      }

      return [fieldError.details];
    });

    if (fieldMessages.length > 0) {
      return fieldMessages;
    }
  }

  if (typeof error.data.message === "string" && error.data.message.length > 0) {
    return [error.data.message];
  }

  return [];
};
